<template>
  <div class="main" style="position: relative">
    <div class="stars">
      <div v-for="(item,index) in starsCount" :key="index" class="star" ref="star">
      </div>
    </div>
    <div class="phone-login" v-show="!isToggle">
      <a-form-model id="formLogin" ref="form" class="user-layout-login" :model="form" :rules="rules">
        <a-alert
          v-if="isLoginError"
          type="error"
          showIcon
          style="margin-bottom: 24px"
          :message="loginErrorInfo"
          closable
          :after-close="handleCloseLoginError"
        />
        <h3>验证码登录</h3>
        <!-- <div class="scan">
          <a-icon type="safety-certificate" theme="filled" />
          <span>扫码登录更安全</span>
        </div> -->
        <!-- <img @click="toggleLogin" class="img-scan1" src="../../assets/icons/bgcode.svg" /> -->
        <a-form-model-item prop="corpid">
          <a-input ref="userNameInput" value="成都捷云智慧科技有限公司" disabled>
            <a-icon slot="prefix" type="user" />
          </a-input>
        </a-form-model-item>
        <a-form-model-item prop="username">
          <a-input v-model="form.phone" size="large" placeholder="请输入手机账号">
            <a-icon slot="prefix" type="phone" :style="{ color: 'rgba(0,0,0,.25)' }" />
          </a-input>
        </a-form-model-item>

        <a-row :gutter="16" v-if="captchaOnOff">
          <a-col :span="16">
            <a-form-model-item prop="code">
              <a-input v-model="form.code" size="large" type="text" autocomplete="off" placeholder="请输入验证码">
                <a-icon slot="prefix" type="security-scan" :style="{ color: 'rgba(0,0,0,.25)' }" />
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-button
              style="height: 39px; width: 110px; font-size: 12px; background-color: var(--ThemeColor); border: none"
              :type="btn.type"
              @click="getVerificationCode"
              :disabled="btn.disabled"
            >
              {{ btn.text }}
            </a-button>
          </a-col>
        </a-row>
        <a-form-item style="margin-top: 24px">
          <a-button
            size="large"
            type="primary"
            htmlType="submit"
            class="login-button"
            :loading="logining"
            :disabled="logining"
            @click="handleSubmit"
          >登录</a-button
          >
        </a-form-item>
        <div class="box">
          <a-button
            class="WeChatBtn"
            :href="'http://admin.win2biz.cn/prod-api/cpwx/authorization/login?timeStamp=' + timeStamp"
          ></a-button>
        </div>
      </a-form-model>
    </div>

    <div class="scan-login" v-show="isToggle">
      <div class="if-box">
        <!-- <iframe
          :src="'http://admin.win2biz.cn/prod-api/cpwx/authorization/login?timeStamp=' + timeStamp"
          class="qr-iframe"
          scrolling="no"
          frameborder="no"
        >
        </iframe> -->
        <a-button type="link" :href="'http://admin.win2biz.cn/prod-api/cpwx/authorization/login?timeStamp=' + timeStamp">企业微信登录</a-button>
      </div>

      <!-- <div class="scan-tips">
        <a-icon type="safety-certificate" theme="filled" />
        <span>请使用企业微信扫码登录更安全</span>
      </div> -->
      <!-- <svg
        t="1647956343685"
        class="icon"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="18346"
        width="100"
        height="100"
        color="#fff"
        @click="toggleLogin"
      >
        <path
          d="M746.666667 85.333333c64.8 0 117.333333 52.533333 117.333333 117.333334v618.666666c0 64.8-52.533333 117.333333-117.333333 117.333334H277.333333c-64.8 0-117.333333-52.533333-117.333333-117.333334V202.666667c0-64.8 52.533333-117.333333 117.333333-117.333334h469.333334zM597.333333 778.666667H426.666667a32 32 0 0 0 0 64h170.666666a32 32 0 0 0 0-64z m149.333334-629.333334H277.333333a53.333333 53.333333 0 0 0-53.333333 53.333334v480h576V202.666667a53.333333 53.333333 0 0 0-53.333333-53.333334z"
          p-id="18347"
        ></path>
      </svg> -->

      <img @click="toggleLogin" src="../../assets/images/password.svg" alt="" />
      <div class="bg-top-right"></div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { timeFix } from '@/utils/util'
import { getCodeImg, getCodePhone } from '@/api/login'
import { LOGIN_USERNAME, LOGIN_PASSWORD, LOGIN_REMEMBERME, LOGIN_TIMESTAMP, ACCESS_TOKEN } from '@/store/mutation-types'
import storage from 'store'
export default {
  components: {},
  data () {
    return {
      starsCount: 800, // 星星数量
      distance: 800, // 间距
      btn: {
        type: 'primary',
        text: '获取验证码',
        time: 120,
        disabled: false
      },
      codeUrl: '',
      isLoginError: false,
      loginErrorInfo: '',
      form: {
        corpId: 'wp1a3ABwAAWQtda3sIq26AgOKIYWkn4A',
        // corpId: 'wwbca83946cfdc2782',
        // username: 'admin',
        // password: 'admin123',
        phone: '18981818883',
        code: 6666,
        uuid: '',
        rememberMe: false
      },
      rules: {
        // username: [{ required: true, message: '请输入帐户名', trigger: 'blur' }],
        // password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        phone: [{ required: true, message: '请输手机号', trigger: 'blur' }],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      },
      timeStamp: undefined,
      logining: false,
      captchaOnOff: true,
      isToggle: false, // 是否切换登录方式
      codeTime: 20,
      intervalCodeTime: null
    }
  },
  mounted () {
    const _this = this
    const starArr = _this.$refs.star
    console.log(starArr)
    starArr.forEach(item => {
      var speed = 0.2 + (Math.random() * 1)
      var distance_ = _this.distance + (Math.random() * 300)
      item.style.transformOrigin = `0 0 ${distance_}px`
      item.style.transform = `translate3d(0,0,-${distance_}px) 
      rotateY(${(Math.random() * 360)}deg) rotateX(${(Math.random() * 360 - 50)}deg) scale(${speed},${speed})`
    })
  },
  created () {
    this.timeStamp = new Date().getTime()
    this.getStorage()
    if (this.$route.query.token != undefined) {
      storage.set(ACCESS_TOKEN, this.$route.query.token, 7 * 24 * 60 * 60 * 1000)
      this.loginSuccess(this.$route.query)
    }
  },

  methods: {
    toggleLogin () {
      this.isToggle = !this.isToggle
      if (this.isToggle) {
        this.getScanCodeTime()
      } else {
        clearInterval(this.intervalCodeTime)
      }
    },
    getCode () {
      getCodeImg().then((res) => {
        this.captchaOnOff = res.captchaOnOff === undefined ? true : res.captchaOnOff
        if (this.captchaOnOff) {
          this.codeUrl = 'data:image/gif;base64,' + res.data.img
          this.form.uuid = res.data.uuid
        }
      })
    },
    getPhoneCode () {
      const that = this
      getCodePhone({
        phone: this.form.phone,
        corpId: this.form.corpId
      }).then((res) => {
        if (res.code === 200) {
          that.$message.success('发送成功')
        } else {
          that.$message.error(res.msg)
        }
      })
    },
    getStorage () {
      const username = storage.get(LOGIN_USERNAME)
      const password = storage.get(LOGIN_PASSWORD)
      const rememberMe = storage.get(LOGIN_REMEMBERME)
      if (username) {
        this.form = {
          username: username,
          password: password,
          rememberMe: rememberMe
        }
      }
    },
    rememberMe (e) {
      this.form.rememberMe = e.target.checked
    },
    ...mapActions(['Login', 'Logout', 'PhoneLogin', 'CodeLogin']),
    handleSubmit () {
      this.logining = true
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.form.rememberMe) {
            storage.set(LOGIN_USERNAME, this.form.username)
            storage.set(LOGIN_PASSWORD, this.form.password)
            storage.set(LOGIN_REMEMBERME, this.form.rememberMe)
          } else {
            storage.remove(LOGIN_USERNAME)
            storage.remove(LOGIN_PASSWORD)
            storage.remove(LOGIN_REMEMBERME)
          }
          this.PhoneLogin(this.form)
            .then((res) => this.loginSuccess(res))
            .catch((err) => this.requestFailed(err))
            .finally(() => {
              this.logining = false
            })
        } else {
          setTimeout(() => {
            this.logining = false
          }, 600)
        }
      })
    },
    getVerificationCode () {
      const that = this
      if (that.btn.disabled) {
        return
      } else {
        // 发送验证码 TODO
        this.getPhoneCode()
        that.btn.disabled = true
        that.btn.time = that.btn.time - 1
        that.btn.text = '重新获取(' + that.btn.time + 's)'
        that.btn.type = ''
      }
      const interval = setInterval(function () {
        if (that.btn.time > 0) {
          that.btn.time = that.btn.time - 1
          that.btn.text = '重新获取(' + that.btn.time + 's)'
          that.btn.type = ''
        } else {
          clearInterval(interval)
          that.btn.text = '获取验证码'
          that.btn.type = 'primary'
          that.btn.disabled = false
          that.btn.time = 120
        }
      }, 1000)
    },
    loginSuccess (res) {
      if (res.init === 1) {
        this.$router.push({ path: '/account/settings' })
        // 延迟 1 秒显示欢迎信息
        setTimeout(() => {
          this.$notification.success({
            message: '欢迎',
            description: `${timeFix()}，欢迎回来,请完善个人信息`
          })
        }, 1000)
        this.handleCloseLoginError()
      } else {
        this.$router.push({ path: '/' })
        // 延迟 1 秒显示欢迎信息
        setTimeout(() => {
          this.$notification.success({
            message: '欢迎',

            description: `${timeFix()}，欢迎回来`
          })
        }, 1000)
        this.handleCloseLoginError()
      }
    },
    requestFailed (err) {
      this.isLoginError = true
      this.loginErrorInfo = err
      this.form.code = undefined
    },
    handleCloseLoginError () {
      this.isLoginError = false
      this.loginErrorInfo = ''
    },
    /***
     *定时器调用扫码登录是否过期
     */
    getScanCodeTime () {
      const that = this
      that.intervalCodeTime = setInterval(function () {
        if (that.codeTime > 0) {
          that.codeTime = that.codeTime - 1
          that
            .CodeLogin(that.timeStamp)
            .then((res) => that.loginSuccess(res))
            .finally(() => {
              that.logining = false
            })
        } else {
          clearInterval(that.intervalCodeTime)
          that.btn.time = 20
        }
      }, 1000)
    }
  }
}
</script>
<style type="text/css">
body.userLayout{
  background:radial-gradient(200% 100% at bottom center,#f7f7b6,#e96f92),url(/img/background.d71ca35a.png) no-repeat 50%;
  background:radial-gradient(220% 100% at top center,#1b2947 10%,#75517d 40%,#e96f92 65%,#f7f7b6),url(/img/background.d71ca35a.png) no-repeat 50%;
  background-attachment: fixed;
  overflow: hidden;
}
#userLayout.user-layout-wrapper .container{
  background-color:transparent !important;
  background-attachment: fixed;
}
#app{
  background-color:transparent !important;
}
@keyframes rotate{
  0%{
    /* transform:perspective(400px) rotateZ(20deg) rotateX(-40deg) rotateY(0); */
    transform:perspective(500px) rotateZ(0deg) rotateX(0deg) rotateY(0);
  }
  100%{
    /* transform:perspective(400px) rotateZ(20deg) rotateX(-40deg) rotateY(-360deg); */
    transform:perspective(500px) rotateZ(0deg) rotateX(0deg) rotateY(-360deg);
  }
}
.stars{
  transform:perspective(500px);
  transform-style: preserve-3d;
  position: absolute;
  perspective-origin: 50% 100%;
  left:50%;
  animation: rotate 90s infinite linear;
  bottom:0;
}
.star{
  width:2px;
  height: 2px;
  background:#f7f7b8;
  position:absolute;
  top:0;
  left: 0;
  backface-visibility: hidden;
}
</style>
<style lang="less" scoped>
// 手机登录
.qr-iframe {
  width: 100%;
  height: 100%;
  display: inline;
  position: absolute;
  z-index: 1;
  top: -34px;
  left: -36px;
}
.if-box {
  position: relative;
  height: 400px;
  width: 360px;
  overflow: hidden;
  margin: 0 auto;
  background: #fff;
  border-radius: 4px;
}
.phone-login {
  .user-layout-login {
    padding: 40px 20px;
    position: relative;
    .scan {
      color: var(--ThemeColor);
      width: 180px;
      height: 36px;
      background-color: var(--MenuBgColor);
      // opacity:0.2;
      display: flex;
      align-items: center;
      position: absolute;
      top: 10px;
      left: 140px;
      & > i {
        font-size: 20px;
        margin-left: 20px;
        margin-right: 20px;
      }
    }
    .img-scan1 {
      width: 40px;
      position: absolute;
      top: 0px;
      right: 0px;
      cursor: pointer;
    }
    & > h3 {
      font-size: 20px;
      margin-top: 10px;
      margin-bottom: 30px;
      font-weight: 540;
    }
    label {
      font-size: 14px;
    }

    .getCaptcha {
      display: block;
      width: 100%;
      height: 40px;
    }

    button.login-button {
      padding: 0 15px;
      font-size: 16px;
      height: 40px;
      width: 100%;
      border: none;
      background-color: var(--ThemeColor);
    }
    .user-login-other {
      text-align: left;
      margin-top: 24px;
      line-height: 22px;
      .register {
        float: right;
      }
    }
    .get-check-box {
      width: 100%;
      height: 40px;
      background-color: var(--ThemeColor);
    }
    .box {
      height: 80px;
      position: relative;
      .WeChatBtn {
        border: none;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        width: 50px;
        height: 50px;
        background: url('../../assets/images/login/weixin.png') no-repeat;
        background-size: 200px;
        background-position: -104px -48px;
      }
    }
  }
  .bottom {
    height: 60px;
    background-color: #e8f3ff;
    padding-left: 20px;
    line-height: 60px;
    .divider {
      margin: 0 20px;
    }
  }
}
//扫码登录
.scan-login {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  height: 432px;
  .img-scan {
    width: 50%;
    margin-top: 60px;
  }
  .scan-tips {
    margin-top: 30px;
    color: var(--ThemeColor);
    width: 60%;
    height: 36px;
    background-color: #d6e9ff;
    display: flex;
    align-items: center;
    margin-bottom: 30px;
    & > i {
      font-size: 20px;
      margin-left: 10px;
      margin-right: 4px;
    }
  }
  .icon {
    width: 40px;
    height: 50px;
    color: #fff;
    position: absolute;
    top: 0px;
    right: 0px;
    z-index: 1;
  }
  .bg-top-right {
    position: absolute;
    top: 0px;
    right: 0px;
    box-sizing: border-box;
    border: 28px solid var(--ThemeColor);
    border-color: var(--ThemeColor) var(--ThemeColor) #fff #fff;
  }
  img {
    width: 25px;
    position: absolute;
    top: 2px;
    z-index: 200;
    right: 2px;
  }
  // img{
  //   width: 30px;
  // }
}
.frame_cnt_inside_Small {
  margin: 0 !important;
}
.frame_cnt_inside {
  margin: 0 !important;
}
/deep/html {
  background-color: #fff !important;
}
</style>
